import { Box, Divider, ITheme, Typography, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../store/reducers/store';
import { Utilities } from '../../../utility/utils';
import { ReactComponent as dollarIcon } from '../../../assets/c_dollars.svg';
import { ReactComponent as barsIcon } from '../../../assets/bars.svg';
import { useTranslation } from 'react-i18next';
import FundFeesProvidedValues from './FundFeesProvidedValues';
import SectionTitle from '../common/SectionTitle';
import FundFeesCalculatedProjection from './FundFeesCalculatedProjection';
import useIsFullable from '../../../hooks/useIsFullable';
import LeoAiOverlay from '../../common/LeoAiOverlay';

const FundFeesProjection: React.FC = () => {
    const theme = useTheme() as ITheme;
    const portfolio = useAppSelector(state => state.createPortfolio.portfolio);
    const { t } = useTranslation();

    return <Box display={"flex"} flexDirection={"column"} width={"100%"} bgcolor={theme.palette.background.paper} padding={"12px 26px"} borderRadius={"8px"} gap={"21px"}>
        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
            <Typography fontSize={"24px"} lineHeight={"29.26px"} fontWeight={"700"}>{portfolio.name}</Typography>
            <Box display={"flex"} flexDirection={"column"} alignItems={"flex-end"} gap={"6px"}>
                <Typography fontSize={"22px"} lineHeight={"26.82px"} fontWeight={"600"}>€{Utilities.toFriendlyMoneyValue(portfolio.fundraisingTarget)}</Typography>
                <Typography fontSize={"12px"} lineHeight={"10px"} fontWeight={"600"}>{t('PortfolioPageItemFundraisingTarget')}</Typography>
            </Box>
        </Box>
        <Divider sx={{ margin: "0 -26px" }} />
        <SectionTitle title={t('CreatePortfolioFees')} icon={dollarIcon} />
        <Divider />
        <FundFeesProvidedValues />
        <SectionTitle title={t('CreatePortfolioProjection')} icon={barsIcon} />
        <Divider />
        <FundFeesCalculatedProjection />
    </Box>
}

export default FundFeesProjection